import styled from '@emotion/styled';

export const ZoomButtonsDiv = styled('div')<{
  top?: string;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ZoomButton = styled('button')`
  background-color: #ef476f;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  margin-left: 5px;
  height: 30px;
  padding-top: 4px;
`;

export const CloseButton = styled('button')`
  border: 1px solid #000000;
  cursor: pointer;
  border-radius: 5px;
  margin-left: 5px;
  height: 30px;
  padding-top: 4px;
`;

export const BorderButton = styled('button')`
  background-color: #000000;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  margin-left: 5px;
  height: 30px;
  padding-top: 4px;
`;
